import { useEffect } from 'react';

export function usePageMeta({ title, description, robots, canonical }) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }

    if (robots) {
      let meta = document.querySelector('meta[name="robots"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'robots');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', robots);
    }

    // Always remove any existing canonical first, then add the correct one.
    // This prevents stale canonicals from previous page renders.
    const existing = document.querySelector('link[rel="canonical"]');
    if (existing) existing.remove();

    if (canonical) {
      // Normalise: strip trailing slash except for root "/"
      const normalised = canonical.endsWith('/')
        ? canonical
        : canonical + '/';

      const link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', normalised);
      document.head.appendChild(link);
    }

    return () => {
      // On unmount, remove the canonical so the next page starts clean.
      const link = document.querySelector('link[rel="canonical"]');
      if (link) link.remove();

      // Restore default robots for public pages if this was a noindex page.
      if (robots && robots !== 'index, follow') {
        const meta = document.querySelector('meta[name="robots"]');
        if (meta) meta.setAttribute('content', 'index, follow');
      }
    };
  }, [title, description, robots, canonical]);
}
